import styled, { css } from 'styled-components';

import { GetSCProps } from '@utils/types';
import BaseButton from '@components/Button/next';

type CodeValidationProps = GetSCProps<'isValid'>;
const validMixin = (p: CodeValidationProps) =>
  p.isValid
    ? css`
        &,
        &:hover {
          color: ${p.theme?.palette.validGreen};
          border-color: ${p.theme?.palette.validGreen};
        }
        svg {
          display: initial;
          path {
            fill: ${p.theme?.palette.validGreen};
          }
        }
        span {
          margin-right: 16px;
        }
        pointer-events: none;
      `
    : null;
export const Button = styled(BaseButton)<CodeValidationProps>`
  && {
    svg {
      display: none;
      position: absolute;
      right: 8px;
    }
    ${validMixin}
    position: relative;
    font-size: 16px;
  }
`;

Button.defaultProps = {
  variant: 'Primary',
};
